module.exports = __webpack_public_path__ + "static/Moderat-Bold-646be616fd8409efdaac9fd35a992bc6.woff";